<template>
    <sa-page-layout btnRefreshVisible @refresh="onRefresh">
        <template slot="toolbar-title">
            <paziente-anagrafica :linkPatient="linkPatient" :idPaziente="idPaziente"></paziente-anagrafica>
        </template>
        <template slot="table-body">
            <pazienti-consensi-list-component ref="cmpPazientiConsensiList"></pazienti-consensi-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PazienteAnagrafica from "../../components/PazienteAnagrafica.vue";
import PazientiConsensiListComponent from "../components/PazientiConsensiListComponent.vue";
export default {
    components: { SaPageLayout, PazientiConsensiListComponent, PazienteAnagrafica },
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            jsonData: {},
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient: {
            get: function () {
                if (this.utente.gruppo) {
                    if (this.utente.gruppo.menuGruppo) {
                        if (this.utente.gruppo.menuGruppo.length == 1) {
                            if (this.utente.gruppo.menuGruppo[0].primaryKey === "homestudiomedico") {
                                return "/paziente/view/" + this.idPaziente;
                            } else if (this.utente.gruppo.menuGruppo[0].primaryKey === "pazienti") {
                                return "view/" + this.idPaziente;
                            } else {
                                return "/homepaziente";
                            }
                        } else {
                            return "";
                        }
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
            },
        },
    },
    mounted() {
        let me = this;
        this.$refs.cmpPazientiConsensiList.setDati(me.idPaziente, "BOTOX");
    },
    methods: {
        onRefresh() {
            this.$refs.cmpPazientiConsensiList.loadData();
        },
    },
};
</script>

<style lang="scss" scoped></style>
